module.exports = __webpack_public_path__ + "static/img/inedxbb.8c6a053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/inedxbb.png
// module id = BPzv
// module chunks = 1